import { StateObservable } from 'redux-observable';
import { map } from 'rxjs/operators';

import { VariablesEditorDialogAction, State } from '../..';
import { Observable } from 'rxjs';
import { EpicDependencies } from '../../dependencies.interface';
import { createSetUseCategories } from '../../actions';
/**
 * Epic to set the useCategories state from an API observable.
 * This epic listens to the useCategories$ observable and dispatches an action
 * to update the state with the received value.
 *
 * @param _actions$ - Observable of actions (not used in this epic).
 * @param _store - Redux store (not used in this epic).
 * @param dependencies - Dependencies containing the useCategories$ observable.
 * @returns Observable of VariablesEditorDialogAction that updates the useCategories state.
 */
export const setUseCategoriesFromApi = (
  _actions$: Observable<VariablesEditorDialogAction>,
  _state$: StateObservable<State>,
  dependencies: EpicDependencies,
): Observable<VariablesEditorDialogAction> => dependencies.useCategories$.pipe(map(createSetUseCategories));
